import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import InfoIcon from '@material-ui/icons/Info';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';

const useStyles = makeStyles((theme) => ({
  paragraph: {
    whiteSpace: 'pre-line',
  },
  title: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1) / 2,
    fontWeight: 500
  },
  subtitle: {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(3),
    fontWeight: 300
  },
  agenda: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    fontWeight: 300
  },
  bullets: {
  },
  bullet: {
    marginBottom: theme.spacing(2),
  },
  bulletTitle: {
    fontWeight: 500,
    marginBottom: theme.spacing(1) / 2,
  },
  bulletSubTitle: {
    fontWeight: 400,
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  card: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(3)
  }
}));

const Agenda = (props) => {
  const classes = useStyles();
  return (
    <>
      { props.config &&
        <>
          <h3 className={classes.agenda}>{props.config.title}</h3>
          <div className={classes.bullets}>
            {props.config.bullets && props.config.bullets.map((bullet, index) => (
              <div className={classes.bullet} key={index}>
                <h4 className={classes.bulletTitle}>{bullet.title}</h4>
                <h6 className={classes.bulletSubTitle}>{bullet.subtitle}</h6>
              </div>
            ))}
          </div>
        </>
      }
    </>
  );
};

export default (props) => {
  const classes = useStyles();
  return (
    <>
      <Grid container spacing={5}>
        <Grid item xs={12} md={8}>
          <h2 className={classes.title}>{props.config.title}</h2>
          <h3 className={classes.subtitle}>{props.config.subtitle}</h3>
          <p className={classes.paragraph}>{props.config.description}</p>
          <Agenda config={props.config.agenda} />
        </Grid>
        <Grid item xs={12} md={4}>

          {props.config.survey && props.config.survey.isOpen &&
            <Card className={classes.card}>
              <h4>{props.config.survey.title}</h4>
              <p>{props.config.survey.description}</p>
              <div className={classes.button}><Button size="small" variant="contained" color="primary" href={props.config.survey.url} target="_blank" rel="noopener noreferrer" startIcon={<SpeakerNotesIcon />} disableElevation>survey</Button></div>
            </Card>
          }
          
          <Card className={classes.card}>
            <h4>Find out more</h4>
            <p>Visit the AEEA website to read more about the awards and our previous winners.</p>
            <div className={classes.button}><Button size="small" variant="contained" color="primary" href="https://aeea.engineersaustralia.org.au" target="_blank" rel="noopener noreferrer" startIcon={<InfoIcon />} disableElevation>more info</Button></div>
          </Card>

          <Card className={classes.card}>
            <h4>Need help?</h4>
            <p>If you are experiencing technical difficulties please submit a question with support</p>
            <div className={classes.button}><Button size="small" variant="contained" color="primary" href="https://corrivium.zendesk.com" target="_blank" rel="noopener noreferrer" startIcon={<ContactSupportIcon />} disableElevation>chat</Button></div>
          </Card>

        </Grid>
      </Grid>
    </>
  );
}